import React from 'react'
import { useEffect } from 'react'
import { useNavigate,useLocation } from 'react-router-dom'
import AiwellLogo from '../Assets/images/Aiwell Logo 1.png';
import SplashScreenLogo from '../Assets/images/Splash rotation logo.png'
import Ayurailogo from '../Assets/images/logo (1).png'
function SplashScreen() {

    let navigate = useNavigate()
    const location = useLocation();


    useEffect(() => {
        setTimeout(() => {
            navigate('/Welcome', { state: { from: location.state?.from } })
        }, 2500)
    })

    return <div className='SplashScreen'>

        <div className='Aiwell-splash-logo'>
            <img src={AiwellLogo}>
            </img>
        </div>

        <div className='Splash-rotation-logo'>
            <img src={SplashScreenLogo}>
            </img>
        </div>
        <div className='Ayurai-logo'>
            <p>Engineered by</p>
            <img src={Ayurailogo} className='splash-logo'>
            </img>
        </div>
    </div>

}

export default SplashScreen